"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("./Tag.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Tag = function Tag(_ref) {
  var text = _ref.text,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "Normal" : _ref$variant;
  // Class name based on the variant
  var className = "Tag Tag-".concat(variant);
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: className
  }, text);
};
var _default = exports["default"] = Tag;